import { getAdminList } from '@/dataProvider/admins-data-provider/get-list';

export const adminsDataProvider = {
  getList: getAdminList,
};
